export default __webpack_public_path__ + "static/media/J.ff229da4.mp3";